import { StoreModel } from '../../models/Index';
import { SdkEvents } from 'sdk/index';
import { LogEvents, logger } from 'helpers/Logger';

export default function startReceivingCash(Store: StoreModel, event: any) {
    logger.localLog('Starting CashReceiver.', LogEvents.CashReceiverStarted);

    return Store.shellClient.cashAcceptor
        .startReceivingCash(event.data.appID, event.data.processId)
        .finally(() => {
            Store.sdk.events.emit(SdkEvents.CashAcceptorStarted, {});
        });
}
